import React, { useState } from 'react';
import { isAudioEnabled, persistAudioEnabled, playSound } from '../shared/audio/audio';

const AUDIO_ON_SOUND = '/assets/audio/select-button.mp3';

export default function AudioToggle() {
  const [enabled, setEnabled] = useState(() => isAudioEnabled());

  const toggle = () => {
    const next = !enabled;
    setEnabled(next);
    persistAudioEnabled(next);
    if (next) {
      playSound(AUDIO_ON_SOUND);
    }
  };

  return (
    <button
      type="button"
      className="crm-icon-btn crm-audio-toggle"
      onClick={toggle}
      title={enabled ? 'Audio activado. Clic para silenciar.' : 'Audio silenciado. Clic para activar.'}
      aria-label={enabled ? 'Silenciar audio' : 'Activar audio'}
      aria-pressed={enabled}
    >
      <span className="crm-audio-toggle-emoji" aria-hidden>
        {enabled ? '🔊' : '🔇'}
      </span>
    </button>
  );
}
